module.exports = __webpack_public_path__ + "static/media/icon7.16f46954.svg";